export async function getAllFileNames(
  periodo,
  distribuidor,
  ano,
  trimestre,
  revisao
) {
  let myHeaders = new Headers();
  myHeaders.append("Authorization", "Basic bmV4dXMuYW5kcmU6ZGVjQG5leHVz");

  let requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };
  const apiUrl = `https://boanova183129.protheus.cloudtotvs.com.br:4050/rest/avaliacoes_pex?distribuidor=${distribuidor}&periodo=${periodo}&ano=${ano}&referencia=${trimestre}&revisao=${revisao}`;

  try {
    const response = await fetch(apiUrl, requestOptions);
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error get pex filenames:", error);
  }
}
